export default __webpack_public_path__ + "static/media/unsaved.9112f865.svg";